
<script>
import Vue from "vue";
import func from "../../libs/functions.js";

import { mapGetters, mapActions } from "vuex";

import _ from "lodash";

import _system from "../../libs/system";

import { _is } from './mixins/_is'
import { getPlatformImage } from './mixins/getPlatformImage'

import { Datetime } from "vue-datetime";

Vue.component("datetime", Datetime);
import "vue-datetime/dist/vue-datetime.css";

export default {
  name: "search",
  mixins: [_is, getPlatformImage],
  data() {
    return {
      window: window,
      func,
      conversationId: '',
      active: 0,
      loading: {
        search: false
      },
      text: "",
      messages: [],
      searched: false,
      filter: {
        after: "",
        before: "",
        pageIds: []
      },
      vueDate: {
        after: "",
        before: ""
      }
    };
  },
  computed: {
    ...mapGetters("workspaces", ["workspaces", "currentWorkspace"]),
    ...mapGetters("session", ["isLoggedIn", "getUser"]),
    ...mapGetters("tags", ["tags", "tagsByName", "tagsById", 'getEnumaratedTags']),
    ...mapGetters("workspaces", ["workspaces", "currentWorkspace"]),
    ...mapGetters("accounts", ["accounts", "accountsById", "workspaceAccountsById"]),
    ...mapGetters("networks", ["networksById"]),
    ...mapGetters('htmlModals', ['modals']),
    onlyActiveAccounts() {
      let onlyActivePages = _.filter(this.accounts, account => {
        if ((account.tags && account.tags.indexOf(this.tagsByName["Passive"]._id) == -1) || !account.tags) return account;
      });
      return onlyActivePages;
    }
  },
  methods: {
    ...mapActions("htmlModals", ["setCreateSearchModal", "setConversationModalId", "setConversationModal"]),
    ...mapActions("tags", ["setTags"]),
    ...mapActions("workspaces", [
      "setWorkspaces",
      "pushWorkspace",
      "setCurrentWorkspace"
    ]),
    ...mapActions("workspaceusers", ["setWorkspaceusers"]),
    ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),
    checkActive(item, array) {
      if (array.indexOf(item._id) > -1) {
        return true;
      } else {
        return false;
      }
    },
            openConversation(e, message){
           if( navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) ) return this.$router.push("/inbox?conversation="+ message._id);
          
          if(e.metaKey){
            this.$router.push("/inbox?conversation="+ message._id);
          }else{
            this.setConversationModalId(message._id);
            this.setConversationModal(true);
            document.body.classList.add('overflowYHidden');
          }  
        },
      updateTime(){
        this.loading.search = true;
        setTimeout( () => {
            console.log(this.startDate)
            //console.log(new Date(this.startDate).getTime() / 1000)
            this.filter.after = new Date(this.vueDate.after).getTime()
            this.filter.before = new Date(this.vueDate.before).getTime()
            //this.setInboxFiltersBefore(new Date(this.endDate).getTime())
            
            this.latestMessages();
        }, 1200)
     
      },
    search() {
      if (!this.text.length) return alert("Cannot be empty :)");

      this.loading.search = true;

      let payload = {
        query: {
          text: this.text,
          workspaceId: this.currentWorkspace._id
        }
      };

      if (this.filter.pageIds) payload.query.pageId = this.filter.pageIds
      if (this.filter.after) payload.query.after = this.filter.after;
      if (this.filter.before) payload.query.before = this.filter.before;

      _system.services.messages.search(payload, (err, messages) => {
        if (err) return alert(err.message);

        this.loading.search = false;
        this.searched = true;
        messages = _system.services.messages.helper(messages);
/*         let filtered = _.map(messages, message => {
          if(message.text){
          var check = new RegExp(this.text, "ig");
          message.text = message.text
            .toString()
            .replace(check, function(matchedText, a, b) {
              return (
                '<strong style="background: #fffdd2;">' +
                matchedText +
                "</strong>"
              );
            });

          return message;
          }else{
            return message;
          }

        }); */
        this.messages = messages;
      });
    },
    latestMessages() {
      this.loading.search = true;

      let payload = {
        query: {
          workspaceId: this.currentWorkspace._id,
          limit: 50
        }
      };


      if (this.filter.pageIds) payload.query.pageId = this.filter.pageIds
      if (this.filter.after) payload.query.after = this.filter.after;
      if (this.filter.before) payload.query.before = this.filter.before;

      _system.services.messages.search(payload, (err, messages) => {
        if (err) return alert(err.message);

        this.loading.search = false;
        messages = _system.services.messages.helper(messages);

        this.messages = messages;
      });
    },
    closeModal() {
      this.setCreateSearchModal(false);
      document.body.classList.remove("overflowYHidden");
    },
    throwImgError(event, message) {
      event.srcElement.src =
        "/img/avatar/roboto/128/latin_" +
        message.from.name.charAt(0).toLowerCase() +
        ".png";
    },
    exportData(){

      let payload = {
        query: {
          text: this.text,
          workspaceId: this.currentWorkspace._id
        }
      };

      if (this.filter.pageIds) payload.query.pageId = this.filter.pageIds
      if (this.filter.after) payload.query.after = this.filter.after;
      if (this.filter.before) payload.query.before = this.filter.before;

      _system.services.messages.getCsv(payload, (err, res) => {
        if(err) return alert(err.message);


         var link = document.getElementById('downloadlink');
          link.href = window.URL.createObjectURL(new Blob([res.toString()], {type: 'text/csv;charset=utf-8;'}))
          //link.style.display = 'block';
          link.click();

/*           var csvData = new Blob([res.toString()], {type: 'text/csv;charset=utf-8;'});
          var csvURL = window.URL.createObjectURL(csvData);
          console.log(csvURL);
          var tempLink = document.createElement('a');
          tempLink.href = csvURL;
          tempLink.setAttribute('download', 'ActiveEvent_data.csv');
          tempLink.click(); */
      })
    },
    updateAccounts(account){

          if(!account){
            this.filter.pageIds = []
            this.latestMessages();
            return
          }

          var index = this.filter.pageIds.indexOf(account._id);
          if(index > -1) this.filter.pageIds.splice(index, 1); else this.filter.pageIds.push(account._id);


      this.latestMessages();
    }
  },
  mounted() {
    $('.ui.dropdown').dropdown()
    document.getElementById("searchBox").focus();
    document.body.classList.add("overflowYHidden");
  },
  created() {
    let currentSec = +new Date();

    let currentSecMinus30Days = currentSec - 2592000000;

    this.filter.after = currentSecMinus30Days;
    this.filter.before = currentSec + 86400000 + 111000000;

    this.vueDate.after = new Date(currentSecMinus30Days).toISOString();
    this.vueDate.before = new Date(currentSec + 86400000 + 111000000).toISOString();

    this.currentDate = new Date( currentSec + 86400000 + 111000000 ).toISOString()

    this.latestMessages();
  }
};
</script>

<template>

<div class="modalWrapper">
    <div @click="closeModal()" class="modal"></div>
    <div class="ui grid">
      <div style="padding-right: 0;" class="thirteen wide column centered">
        <div
          @click="closeModal()"
          style="padding-right: 0; padding-bottom:0; z-index:9999999;"
          class="ui basic segment right aligned"
        >
          <a style="background: rgba(0,0,0,0.6);" class="ui black mini button">Close</a>
        </div>
      </div>
    </div>


  <!--   Main Wrapper   -->
    <div class="ui grid">

        <div class="thirteen wide column centered" style="z-index: 9999; background: #ffffff; border-radius: 7px;" >

          <div class="ui grid">

            <!--   Search'LL BE HERE   -->
              <div class="sixteen wide column" >
                <div class="ui action big input fluid">
                  <input
                    id="searchBox"
                    v-model="text"
                    v-on:keyup.enter="search()"
                    style="border:none;"
                    type="text"
                    placeholder="Search in texts, names..."
                  >
                  <button
                    style="border-radius: 5px; background: transparent; color: #ccc; margin-top: -2px;"
                    @click="search();"
                    :class="{ loading: (loading.search) ? true : false }"
                    class="ui icon large button"
                  >
                    <i class="large search icon"></i>
                  </button>
                </div>
              </div>

              <!--   Sub Wrapper Left   -->
              <div class="twelve wide column centered" style="background: #F9F9F9;" >

                <div v-if="loading.search" data-aos="zoom-in" style="height:100%;" class="ui grid centered stackable">
                  <div class="six wide computer sixteen wide mobile column">
                      <div class="ui basic segment center aligned">
                      <div style="padding:0; color: #999;" class="ui basic segment">
                      </div>
                      <div class="loader-inner ball-beat"><div></div><div></div><div></div></div>
                      </div>
                  </div>
              </div>

                <div v-if="!loading.search && !messages.length"
                    style="z-index:1; background: #f9f9f9; margin:0; border-top:1px solid #f1f1f1;border-bottom:1px solid #f1f1f1;"
                    class="ui basic segment center aligned" >
                    <p style="color: #aaaaaa;">Juphy didn't find any results related to your search</p>
                  </div>

                  <div v-if="messages.length" class="ui basic segment no-pad">
                    <div v-for="message in messages" @click="openConversation($event, message)" :key="message._id" class="ui feed main">
                      <div class="event">
                        <div style="width: 4em;position: relative;" class="label">
                          <img
                            style="width: 55px; height:55px;"
                            :src="func.replaceImg(message.from.avatar)"
                          >
                          <img
                            :src="getPlatformImage(message.platform, message)"
                            style="top:40px;width: 1.7rem;height: 1.7rem;font-size: 0.8em;border: 1px solid rgb(249, 249, 249);position: absolute;"
                            alt
                          >
                        </div>
                        <div style="margin-top: 0;" class="content">
                          <div class="summary">
                            <a>{{message.from.name}}</a>
                            <div class="date">{{func.since(message.createdAt)}} ago</div>
                            <div style="float: right;" class="date">
                              <span
                                style="margin-left: 6px;font-weight: 400;font-size: 11px;padding-right: 5px;border-radius: 25px 7px 7px 25px;padding-top: 2px;padding-bottom: 3px;color: #aaa;background: #f9f9f9;"
                              >
                                <img
                                  style="width:18px; opacity: 0.5; height:18px;margin-right:2px; border-radius:5px;vertical-align: middle;"
                                  :src="workspaceAccountsById[message.page].avatar"
                                >
                                {{workspaceAccountsById[message.page].name}}
                              </span>
                            </div>
                          </div>
                          <div
                            style="color: #666;"
                            :style="{ opacity: (_is(message, 'deleted') || _is(message, 'hidden')) ? '.2' : '1' }"
                            class="extra text"
                          >
                            <span style="vertical-align: middle;" v-html="message.text"></span>
                            <div v-if="_is(message, 'deleted')" class="meta">
                              <span style="padding-left: 4px;" class="ui red mini label">Deleted</span>
                            </div>
                            <div v-if="_is(message, 'hidden')" class="meta">
                              <span style="padding-left: 4px;" class="ui black mini label">Hidden</span>
                            </div>
                          </div>
                          <div
                            v-if="message.attachments && networksById[message.platform].name != 'Twitter'"
                            class="extra images"
                          >
                            <a
                              v-for="(attachment, index) in message.attachments"
                              :key="`attachment-${index}`"
                              target="_blank"
                              :href="attachment.src"
                            >
                              <img
                                style="background: #fff;padding: 3px;border: 1px solid #eee;border-radius: 2px;"
                                :src="attachment.src"
                              >
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

              </div>

              <!--   Sub Wrapper Right   -->
              <div class="four wide column" style="background: #F3F3F3;">

                  <div class="ui basic segment no-pad">
                   <div class="ui form">

                           <a @click="exportData()" class="ui small icon fluid button"><i class="download icon"></i> Export Filtered Messages </a>

                           <a href="" id="downloadlink" ref="csvfiledownload" hidden="true" download="mycsv.csv">download</a>

                              <h4 class="ui header">Date</h4>
                            <datetime :max-datetime="currentDate" v-model="vueDate.after" input-id="startDate">
<!--                               <i style="position: absolute;right: 6px;top: 43px; color: #bbb; z-index:1;" for="startDate" slot="before" class="calendar alternate outline icon"></i> -->
                                <template slot="button-confirm" slot-scope="scope" >
                                  <span @click="updateTime()">OK</span>
                                </template>
                            </datetime>
                            <datetime :min-datetime="vueDate.after" :max-datetime="currentDate" v-model="vueDate.before"  input-id="endDate">
                              <!-- <i style="position: absolute;right: 6px;top: 80.5px; color: #bbb; z-index:1;" for="endDate" slot="before" class="calendar alternate outline icon"></i> -->
                                <template slot="button-confirm" slot-scope="scope" >
                                  <span @click="updateTime()">OK</span>
                                </template>
                            </datetime>
                          </div> 
                          <div class="ui hidden divider"></div>
                    <div class="ui form">
                      <h4 class="ui header">Channels</h4>
                      <div class="field filter" style="margin-bottom: 6px;">
                        <div
                          :class="{ 'active' : (!active) ? true : false }"
                          class="filterItem"
                          @click="updateAccounts(null); active = 0;"
                          style=" padding: 5px 10px; border-radiuys: 3px; cursor:pointer;"
                        >
                          <i class="list alternate outline icon"></i> All Accounts
                        </div>
                      </div>
                          <div v-show="accounts" v-for="account in onlyActiveAccounts" :key="account._id"
                            class="field filter"
                            style="margin-bottom: 6px; position:relative; "
                          >
                            <img
                              :src="getPlatformImage(account.platform, null)"
                              style="bottom: 1px;width: 14px;height: 14px;border-radius: 20px;vertical-align: middle;position: absolute;left: 6px;border: 1px solid #fff;"
                              alt
                            >

                            <div
                              :class="{ 'active' : checkActive(account, filter.pageIds)}"
                              class="filterItem"
                              @click="updateAccounts(account); active = account._id;"
                              style="padding: 5px 10px; border-radiuys: 3px; cursor:pointer;"
                            >
                              <img
                                style="width:22px; margin-right:4px; border-radius:6px;vertical-align: middle;"
                                :src="account.avatar"
                              >
                              <span
                                style="font-style:italic;vertical-align: baseline;"
                              >{{account.name.substring(0,23)}}</span>
                            </div>
                            </div>
                          </div>
                                             
                         
                        </div>

              </div>
      
          </div>

        </div>
 
    </div>

  </div>
</template>


<style scoped>
.modalWrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  overflow-x: hidden;
  overflow-y: scroll;
}
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(15, 17, 26, 0.35) none repeat scroll 0% 0%;
  z-index: 9999;
  overflow-x: hidden;
  overflow-y: scroll;
}

.shadow {
  box-shadow: 0px 0px 44px rgba(99, 99, 99, 0.85);
  border: none;
}

.ui.feed > .event > .content .extra.images img {
  width: auto;
  max-width: 10em;
}
.ui.feed.main {
  transition: 0.5s;
  padding: 10px 10px;
  border: 1px solid #f1f1f1;
  border-radius: 5px;
  background: #fff;
}

.ui.feed.main:hover {
  background: #f9fbff;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #e0ebfc;
}

.ui.feed > .event > .label + .content {
  margin: 0.5em 0 0.35714286em 0;
}

.ui.label .detail {
  background: rgba(0, 0, 0, 0.1);
  margin: -0.5833em -0.833em -0.5833em 0.5em;
  padding: 0.5833em 0.833em;
  border-radius: 0 0.28571429rem 0.28571429rem 0;
}

.ui.feed > .event {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0em;
  margin: 0em;
  background: none;
  border-top: none;
}

.ui.feed > .event > .label {
  margin-left: 1.6em;
}

.ui.feed > .event .label {
  border-left: 3px solid #dddddd;
}

.ui.feed > .event > .label {
  display: block;
  flex: 0 0 auto;
  width: 3em;
  height: auto;
  align-self: stretch;
  text-align: left;
}

.ui.feed > .event > .label > img,
.ui.feed > .event > .label > .icon {
  background-color: #eeeeee;
  border-radius: 500rem;
  color: #ffffff;
  width: 3rem;
  height: 3rem;
  line-height: 1.5;
  left: -1.6rem;
  opacity: 1;
  position: relative;
}

.ui.feed > .event > .label img {
  width: 100%;
  height: auto;
  border-radius: 500rem;
}

.ui.feed > .event > .content .extra.text {
  max-width: none;
}

.ui.feed > .event:last-child .label {
  border-left-color: transparent;
}
</style>





// WEBPACK FOOTER //
// src/components/dashboard/search.vue